// ==================== 环境检测工具 ====================

/**
 * 获取用户代理字符串的小写版本
 */
function getUserAgent(): string {
  return navigator.userAgent.toLowerCase()
}

/**
 * 检测是否为 Android 设备
 */
export function isAndroid(): boolean {
  return /android/.test(getUserAgent())
}

/**
 * 检测是否为 iOS 设备
 */
export function isIOS(): boolean {
  return /iphone|ipad|ipod/.test(getUserAgent())
}

/**
 * 检测是否在微信内置浏览器中
 */
export function isInWeChat(): boolean {
  return /micromessenger/.test(getUserAgent())
}

/**
 * 判断是否在微信小程序环境中
 */
export function isInWeChatMiniProgram(): boolean {
  const ua = getUserAgent()

  // 方法1: 检查userAgent中是否包含微信小程序标识（miniprogram 不是微信独有，需同时校验 micromessenger）
  if (ua.includes('miniprogram') && ua.includes('micromessenger')) {
    return true
  }

  // 方法2: 检查是否存在微信小程序特有的全局对象
  const win = window as { __wxjs_environment?: string }
  if (typeof window !== 'undefined' && win.__wxjs_environment === 'miniprogram') {
    return true
  }

  // 方法3: 检查微信小程序API是否可用
  const wx = (window as { wx?: { getSystemInfoSync?: () => unknown; miniProgram?: unknown } }).wx
  if (wx?.getSystemInfoSync) {
    return true
  }

  // 方法4: 检查是否在微信环境中，并且可以访问微信小程序API
  if (ua.includes('micromessenger') && wx?.miniProgram) {
    return true
  }

  return false
}

/**
 * 判断是否在企业微信中
 */
export function isInWeChatWork(): boolean {
  return getUserAgent().includes('wxwork')
}

/**
 * 检测是否在 APP 中
 */
export function isInApp(): boolean {
  const ua = getUserAgent()
  const isFlutter = typeof window !== 'undefined' && !!window.flutter_inappwebview
  return ua.startsWith('ctg-zllx-') || isFlutter
}

/**
 * 是否为普通 H5：独立浏览器打开，不在 App WebView、微信内置浏览器、企业微信或微信小程序中。
 * 组合现有原子检测，避免在业务侧散落重复条件。
 *
 * 如需在 Vue 组件内以计算属性使用，可用同包导出的 `usePlainH5()`。
 */
export function isPlainH5(): boolean {
  return (
    !isInApp() &&
    !isInWeChat() &&
    !isInWeChatWork() &&
    !isInWeChatMiniProgram()
  )
}

/**
 * 检测是否为 PC 桌面浏览器（纯 UA 判定）
 *
 * 判定顺序：先排除 Flutter APP 与微信小程序，仅在其余环境做 PC UA 判定。
 * 移动端 UA（含 Mobi / Android / iPhone）返回 false，其余视为 PC。
 * navigator 不存在（如 SSR / 构建期）时保守返回 false，降级按非 PC（H5）处理。
 */
export function isPC(): boolean {
  if (typeof navigator === 'undefined') {
    return false
  }
  // PC 判定仅在非小程序、非 Flutter 环境生效：APP/小程序 WebView 的桌面级 UA（如 iPad）不得误判为 PC
  if (isInApp() || isInWeChatMiniProgram()) {
    return false
  }
  return !/Mobi|Android|iPhone/i.test(navigator.userAgent)
}
